import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ProductCreateSelectTypePage } from "../product-create/product-create-select-type/product-create-select-type";
import { ProductViewPage } from "../product-view/product-view/product-view";
import { ProductsServices } from "../services";
import { ExportServices } from "../../services/exportServices";
import { ConfigurationServices } from '../../configuration/services';
import { ProviderOrderAddPage } from '../../providers/orders/provider-order-add/provider-order-add';
import { HttpClient } from '@angular/common/http';
import { ImportExcelPage } from '../../components/import-excel/import-excel';
import { TranslateService } from '@ngx-translate/core';
import { AdsServices } from '../../ads/services';

/**
 * Generated class for the ProductListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-list',
  templateUrl: 'product-list.html',
})
export class ProductListPage {
  name_product: string
  searchbar_text: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public productsServices: ProductsServices,
    public exportServices: ExportServices,
    public configurationServices: ConfigurationServices,
    public http: HttpClient,
    public translate: TranslateService,
    public adsServices: AdsServices) {
    this.globals.GAtrackView('Products', 'Products - List', this.globals.restaurant.email, 'View', 'List products', 'Products', '');
  }

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-productos')
    });
    loadingPopup.present();
    // Los tags ya se cargan al inicio de la app en getAllTags()
    this.productsServices.getPagesProducts('all', 50);
    this.productsServices.page_active = 1;
    loadingPopup.dismiss();
    //tutorial
    /*if (this.globals.restaurant.tutorial_product == undefined || !this.globals.restaurant.tutorial_product) {
      this.navCtrl.push(ProductTutorialSlidePage);
    }*/
    this.adsServices.randomProvidersElements();

    this.searchProductNode(this.searchbar_text, 'all');
  }

  openProductCreate() {
    //this.productsServices.foodcost_array_tmp = Array();
    this.productsServices.image_url_product_view = null;
    this.navCtrl.push(ProductCreateSelectTypePage);
  }


  openProductView(product) {
    this.getProductLang(product);
    this.productsServices.image_url_product_view = null;
    this.navCtrl.push(ProductViewPage, {
      product_uid: product.UID,
      product_name: this.name_product,
      product_sub_recipe: product.sub_recipe
    });
  }

  async exportProducts() {
    //Preparar Json para exportar
    var _products = await this.productsServices.getProducts(this.globals.restaurant_uid);

    var data = [];

    for (let product of _products) {
      var _array;
      if (product.sub_recipe) {

        _array = {
          nombre: product.name,
          medida: product.measurement,
          precio: product.price_static,
          pvp: product.pvp,
          proveedor: product.provider_static,
          stock: product.stock,
          alerta_stock: product.stock_alert,
          tags: product.tags_static,
          elaboraicon: product.recipe,
          tiempo: product.time,
          herramientas: product.tools,
          compuesto: 'si',
        };
      } else {

        _array = {
          nombre: product.name,
          medida: product.measurement,
          precio: product.price_static,
          pvp: product.pvp,
          proveedor: product.provider_static,
          stock: product.stock,
          alerta_stock: product.stock_alert,
          tags: product.tags_static,
          compuesto: 'no',
        };
      }

      data.push(_array);
    }

    //
    this.globals.GAtrackView('Products', 'Products - Export', this.globals.restaurant.email, 'View', 'Export products', 'Products', '');
    //llamar funcion exportar
    this.exportServices.exportAsExcelFile(data, 'productos');

  }

  openProviderOrderAdd(element) {
    this.navCtrl.push(ProviderOrderAddPage, {
      element: element,
      type: 'product'
    });
  }


  searchProductNode(value, type) {
    this.searchbar_text = value; //Guardamos el valor del searchbar
    if (value.target) {
      this.productsServices.searchProductNode(value, type);
    }
  }

  nextPage() {
    if (this.productsServices.page_active < this.productsServices.pagesProducts.length) {
      this.productsServices.page_active += 1
    }
    this.productsServices.getListProductsMinMax();
  }
  previusPage() {
    if (this.productsServices.page_active > 1) {
      this.productsServices.page_active -= 1;
    }
    this.productsServices.getListProductsMinMax();
  }
  activePage(number) {
    this.productsServices.page_active = number;
    this.productsServices.getListProductsMinMax();
  }
  importProduct(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    });
  }
  getProductLang(product) {
    if (product.sub_recipe) {
      if (this.globals.restaurant.lang == 'es') {
        this.name_product = product.name;
      } else if (this.globals.restaurant.lang == 'en') {
        this.name_product = product.name_en;
      } else if (this.globals.restaurant.lang == 'fr') {
        this.name_product = product.name_fr;
      } else if (this.globals.restaurant.lang == 'ca') {
        this.name_product = product.name_ca;
      } else if (this.globals.restaurant.lang == 'fr') {
        this.name_product = product.name_fr;
      } else if (this.globals.restaurant.lang == 'de') {
        this.name_product = product.name_de;
      } else if (this.globals.restaurant.lang == 'it') {
        this.name_product = product.name_it;
      }
    } else {
      this.name_product = product.name;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-list/product-list.ts